<template>
    <div class="pt-6 pb-24">
        <iframe
            src="https://www.healthshare.com.au/directory/widget/?skin=hp&health_fund=15"
            width="100%"
            height="400"
        />
    </div>
</template>

<script>
export default {
    mounted() {}
};
</script>
